import { render } from "./ProgramEditItemPane.vue?vue&type=template&id=65942e82&scoped=true&ts=true"
import script from "./ProgramEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramEditItemPane.vue?vue&type=style&index=0&id=65942e82&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65942e82"]])

export default __exports__